import Vue from 'vue'
import App from './App.vue'
import globle from './common/globle'
import {router} from './route'
import VueRouter from "vue-router";
import store from './store';
import api from './common/api';
import {Radio, RadioGroup, Button, Autocomplete, Progress, Popover,
    Notification, Message, Loading, Dialog, DatePicker} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueSocketIO from 'vue-socket.io';
import echarts from 'echarts';

import dateFormat from './common/Date';
// import * as fundebug from "fundebug-javascript";
// import fundebugVue from "fundebug-vue";
// fundebug.apikey = "01fdb26dafa1159f215b58df09037ca4e22ec770821d3ba697329c370dcac022"
// fundebugVue(fundebug, Vue);

Vue.prototype.$globle = globle;
Vue.prototype.$api = api;
Vue.config.devtools = true;
Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(Popover);
Vue.use(Loading.directive);
Vue.use(Radio).use(RadioGroup).use(Autocomplete).use(Dialog).use(Button).use(DatePicker).use(Progress);
Vue.prototype.$message = Message;
Vue.prototype.$loading = Loading.service;
Vue.prototype.$echarts = echarts;
Vue.prototype.$notify = Notification;
Vue.use(new VueSocketIO({
    debug: false,
    connection: 'https://push.tnb22.cc:2120/',
    vuex: {
        store,
        actionPrefix: 'SOCKET_',
        mutationPrefix: 'SOCKET_'
    }
}));
Date.prototype.format = function (format) {
    return dateFormat.formatDate(this, format || "yyyy-MM-dd");
};

Vue.filter('formatDate', function (time, format) {
    let date = new Date(time);
    return dateFormat.formatDate(date, format || "yyyy-MM-dd");
});

new Vue({
    router, store,
    render: h => h(App),
}).$mount('#app');
